import styled from 'styled-components';
// import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.span`
  display: inline-block;
  font-size: 14px;
`);



// WEBPACK FOOTER //
// ./src/components/text/SmallText.js